import Form from 'antd/lib/form';

const { Item } = Form;

const Label = Item;

export default Label;
